<template>
  <svg
    v-if="blockType === 'mj-text'"
    height="36"
    viewBox="0 0 64 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 5V11C12 11.5625 12.4375 12 13 12C13.5 12 14 11.5625 14 11V6H23V30H19C18.4375 30 18 30.5 18 31C18 31.5625 18.4375 32 19 32H29C29.5 32 30 31.5625 30 31C30 30.5 29.5 30 29 30H25V6H34V11C34 11.5625 34.4375 12 35 12C35.5 12 36 11.5625 36 11V5C36 4.5 35.5 4 35 4H13C12.4375 4 12 4.5 12 5ZM32 17V21C32 21.5625 32.4375 22 33 22C33.5 22 34 21.5625 34 21V18H41V30H38C37.4375 30 37 30.5 37 31C37 31.5625 37.4375 32 38 32H46C46.5 32 47 31.5625 47 31C47 30.5 46.5 30 46 30H43V18H50V21C50 21.5625 50.4375 22 51 22C51.5 22 52 21.5625 52 21V17C52 16.5 51.5 16 51 16H33C32.4375 16 32 16.5 32 17Z"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="blockType === 'mj-image'"
    height="36"
    viewBox="0 0 64 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.25 11.875C35.5625 10.8125 33.8125 10.8125 33.0625 11.875L28.5 18.8125L27.5 17.375C26.75 16.375 25.0625 16.375 24.375 17.375L20.3125 23C19.9375 23.5625 19.875 24.3125 20.1875 25C20.5 25.625 21.1875 26 21.875 26H42.0625C42.75 26 43.4375 25.625 43.75 25C44.0625 24.375 44.0625 23.625 43.625 23.0625L36.25 11.875ZM21.9375 24L25.875 18.5625L27.75 21.125C27.9375 21.4375 28.25 21.625 28.5625 21.5625C28.875 21.5625 29.1875 21.375 29.375 21.125L34.625 13L41.9375 24H21.9375ZM43.9375 4H19.9375C17.75 4 15.9375 5.8125 15.9375 8V28C15.9375 30.25 17.75 32 19.9375 32H43.9375C46.125 32 47.9375 30.25 47.9375 28V8C47.9375 5.8125 46.1875 4 43.9375 4ZM46 28C46 29.125 45.0625 30 44 30H20C18.875 30 18 29.125 18 28V8C18 6.9375 18.875 6 20 6H44C45.0625 6 46 6.9375 46 8V28ZM25 14C26.625 14 28 12.6875 28 11C28 9.375 26.625 8 25 8C23.3125 8 22 9.375 22 11C22 12.6875 23.3125 14 25 14ZM25 10C25.5 10 25.9375 10.5 25.9375 11C25.9375 11.5625 25.5 12 25 12C24.4375 12 24 11.5625 24 11C24 10.5 24.4375 10 25 10Z"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="blockType === 'mj-button'"
    height="36"
    viewBox="0 0 64 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 10.25C9 7.90279 10.9028 6 13.25 6H50.75C53.0972 6 55 7.90279 55 10.25V21.75C55 24.0972 53.0972 26 50.75 26H47.5C46.9477 26 46.5 25.5523 46.5 25C46.5 24.4477 46.9477 24 47.5 24H50.75C51.9926 24 53 22.9926 53 21.75V10.25C53 9.00736 51.9926 8 50.75 8H13.25C12.0074 8 11 9.00736 11 10.25V21.75C11 22.9926 12.0074 24 13.25 24H30.75C31.3023 24 31.75 24.4477 31.75 25C31.75 25.5523 31.3023 26 30.75 26H13.25C10.9028 26 9 24.0972 9 21.75V10.25Z"
      fill="currentColor"
    />
    <path
      d="M34 18.7491V30.298C34 30.7038 34.2812 30.9847 34.6875 30.9847C34.875 30.9847 35.0625 30.9223 35.1875 30.7662L37.7812 27.8009L39.5938 31.4529C39.8438 31.9523 40.4375 32.1396 40.9375 31.8899C41.4375 31.6402 41.625 31.0471 41.375 30.5477L39.5938 26.9894H43.2812C43.6875 26.9894 44 26.7085 44 26.3027C44 26.1154 43.9062 25.9282 43.75 25.8033L35.1875 18.1873C35.0625 18.0936 34.875 18 34.7188 18C34.3125 18 34 18.3433 34 18.7491Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts" setup>
  defineProps<{
    blockType: "mj-text" | "mj-image" | "mj-button";
  }>();
</script>
